import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guards/authenticated.guard';
import { UnauthenticatedGuard } from '@core/guards/unauthenticated.guard';
import { HasTableSessionGuard } from '@core/guards/has-table-session.guard';
import { RootGuard } from '@core/guards/root.guard';
import { ScanQrGuard } from '@core/guards/scan-qr-guard.guard';
import { QrScannerComponent } from '@features/auth/components/qr-scanner/qr-scanner';
import { EmploymentInvitationResponseComponent } from '@features/admin/components/employment-invitation-response/employment-invitation-response';
import { HomeComponent } from '@features/client/components/home/home-component';
import { PublicBillSplitJoinPageComponent } from './store-front/components/public-bill-split/pages/public-bill-split-join-page/public-bill-split-join-page';
import { PublicBillSplitParticipantPageComponent } from './store-front/components/public-bill-split/pages/public-bill-split-participant-page/public-bill-split-participant-page';
import { PublicBillSplitSharedPageComponent } from './store-front/components/public-bill-split/pages/public-bill-split-shared-page/public-bill-split-shared-page';
import { AdminGuard } from '@core/guards/admin.guard';
import { HomeRedirectGuard } from '@core/guards/home-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [HomeRedirectGuard],
    component: HomeComponent,
    title: 'Dinno - Escaneá, Pedí, Disfrutá',
  },

  // 🔐 Rutas de autenticación
  {
    path: 'auth',
    canActivate: [UnauthenticatedGuard],
    loadChildren: () => import('@features/auth/auth.routes'),
  },
  {
    path: 'role-selection',
    loadComponent: () =>
      import('@features/auth/pages/role-selection/role-selection').then(
        (m) => m.RoleSelectionComponent,
      ),
  },
  {
    path: 'scan-camera',
    component: QrScannerComponent,
  },

  // 📱 Escaneo de QR
  {
    path: 'scan-qr/:tableId',
    canActivate: [ScanQrGuard],
    loadComponent: () =>
      import('@features/auth/pages/qr-scan-handler/qr-scan-handler').then(
        (m) => m.QrScanHandlerComponent,
      ),
  },

  {
    path: 'profile',
    canActivate: [AuthenticatedGuard],
    loadComponent: () =>
      import('@features/client/pages/profile-page/profile-page').then((m) => m.ProfilePage),
  },

  // 🏠 Store - Sesión Activa
  {
    path: 'session/:tableSessionId',
    canActivate: [HasTableSessionGuard],
    loadChildren: () => import('@features/client/client.routes'),
  },

  // 🍽️ Restaurantes (público)
  {
    path: 'food-venues',
    loadChildren: () => import('@features/food-venue/food-venue.routes'),
    title: 'Restaurantes Disponibles',
  },
  {
    path: 'divisor-cuenta',
    loadChildren: () =>
      import('./store-front/components/public-bill-split/public-bill-split.routes').then(
        (m) => m.PublicBillSplitRoutes,
      ),
    title: 'Divisor de cuenta - Dinno',
  },
  {
    path: 'division-cuenta/join/:splitId',
    component: PublicBillSplitJoinPageComponent,
  },
  {
    path: 'division-cuenta/participar/:splitId',
    component: PublicBillSplitParticipantPageComponent,
  },
  {
    path: 'division-cuenta/:splitId',
    component: PublicBillSplitSharedPageComponent,
  },
  {
    path: 'root-admin',
    canActivate: [RootGuard],
    loadChildren: () => import('@features/root/root.routes').then((m) => m.ROOT_ROUTES),
  },
  // ADMIN
  {
    path: 'admin',
    canActivate: [AdminGuard],
    loadChildren: () => import('@features/admin/admin.routes'),
  },

  // EMPLOYEES
  {
    path: 'employee',
    canActivate: [AuthenticatedGuard],
    loadChildren: () => import('@features/employee/employee.routes'),
  },

  {
    path: 'invitations/respond',
    component: EmploymentInvitationResponseComponent,
  },

  {
    path: '**',
    redirectTo: '',
  },
];
